var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRandomizeActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.502,
    height: 16.671,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.01 13.449h0l.624-.624a.772.772 0 111.092 1.092l-1.95 1.95a.754.754 0 01-1.092 0l-1.95-1.95a.772.772 0 011.092-1.092l.624.624V9.471a3.129 3.129 0 013.12-3.12h3.9V1.28a.78.78 0 111.56 0v5.071h3.9a3.129 3.129 0 013.12 3.12v3.978l.624-.624a.772.772 0 011.092 1.092l-1.95 1.95a.754.754 0 01-1.092 0l-1.95-1.95a.772.772 0 011.092-1.092l.624.624V9.471a1.565 1.565 0 00-1.56-1.56H5.571a1.565 1.565 0 00-1.56 1.56z",
    fill: "#5300f2",
    stroke: "#5300f2",
    fillRule: "evenodd",
    "data-name": "Group 1063"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRandomizeActive);
export default __webpack_public_path__ + "static/media/randomize-active.6f0029798f648e7ba1c7563923f52703.svg";
export { ForwardRef as ReactComponent };